module.exports = __webpack_public_path__ + "img/hot.5627982a.png";